import script from "./fission.vue?vue&type=script&lang=ts&setup=true"
export * from "./fission.vue?vue&type=script&lang=ts&setup=true"

import "./fission.vue?vue&type=style&index=0&id=fc60beca&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc60beca"]])

export default __exports__